.wrapper {
  width: 100%;
  padding: 0 20px 0;
}

.content {
  margin: 0 auto;
}

.title {
  margin: 0 0 30px;
  color: #221e1a;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: clamp(24px, 6vw, 32px);
  font-weight: 700;
  line-height: 1.2;

  span {
    color: var(--ed-brand, #ae66f6);
  }
}

.card {
  position: relative;
  width: 100%;
  padding: 0 3px 3px;
  border-radius: 32px;
  background: url(./img/bg.png) no-repeat;
  background-position: center top;
  background-size: 100% 100%;
  overflow: visible;
}

.header {
  position: relative;
  display: flex;
  align-items: center;
  padding: 7px 16px 3px;
  z-index: 2;
  padding-right: 43%;

  span {
    color: #fffbf2;
    font-family: 'SF Pro Text', 'SF Pro', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 860;
    line-height: 16px;
    letter-spacing: 0.26px;
    text-transform: uppercase;
  }
}

.avatarWrapper {
  position: absolute;
  top: -20px;
  right: 16px;
  width: 88px;
  height: 88px;
  z-index: 3;
  background: #F0930C;
  border-radius: 50%;
}

.avatarImageWrapper {
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.avatarWrapper::before {
  content: "";
  display: block;
  background: url(./img/label.png) no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  bottom: -16px;
  right: 0;
  width: 40px;
  height: 40px;
}

.avatar {
  width: calc(100% - 10px);
  object-fit: contain;
}

.cardBody {
  position: relative;
  z-index: 1;
  border-radius: 32px;
  background: #fffbf2;
  padding: 16px 16px 16px 24px;
}

.row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #221e1a;
  font-size: 16px;
  line-height: 20px;

  & + & {
    margin-top: 12px;
  }
}

.row:first-child {
  padding-right: 80px;
}

.rowTop {
  align-items: flex-start;
}

.label {
  flex: 0 0 auto;
  font-weight: 400;
  white-space: nowrap;
}

.value {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 700;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
}

@media (min-width: 376px) {
  .card {
    background-image: url(./img/bgDesktop.png);
  }

  .header {
    padding: 14px 43% 4px 16px;
  }
}

@media (max-width: 360px) {
  .wrapper {
    padding-left: 16px;
    padding-right: 16px;
  }

  .title {
    margin-bottom: 26px;
    font-size: 22px;
  }

  .header span {
    font-size: 12px;
  }

  .avatar {
    right: 10px;
    width: 84px;
    height: 84px;
  }

  .cardBody {
    padding-left: 18px;
    padding-right: 14px;
  }

  .row {
    font-size: 15px;
    line-height: 19px;
  }
}


@media (max-width: 365px) {
  .card {
    background-image: url(./img/bgMin.png);
  }

  .header {
    padding: 14px 40% 4px 16px;
  }
}